import type { BadgeColor } from '@enamelai/design-system'

export enum RoomType {
  GENERAL = 'General',
  EXAM = 'Exam',
  HYGIENE = 'Hygiene',
  SURGERY = 'Surgery',
  ORTHO = 'Ortho',
  MULTI_PURPOSE = 'Multi-purpose',
}

export const roomTypes = Object.values(RoomType)

export const ROOM_TYPE_BADGE_COLORS: Record<RoomType, BadgeColor> = {
  [RoomType.GENERAL]: 'vivid-green',
  [RoomType.EXAM]: 'blue',
  [RoomType.HYGIENE]: 'teal',
  [RoomType.SURGERY]: 'purple',
  [RoomType.ORTHO]: 'indigo',
  [RoomType.MULTI_PURPOSE]: 'orange',
}

export const PROVIDER_BADGE_COLOR: BadgeColor = 'blue'

/** Room types and provider IDs are stored as comma-separated strings. */
export const splitList = (value?: string | null): string[] =>
  (value ?? '')
    .split(',')
    .map((item) => item.trim())
    .filter(Boolean)
